import React from 'react';
import { Container, Stack } from '@drone-js/core';
import { ContentHandlerProps } from 'component/page/detail/DetailPageModularize/contentRegistry.type';
import DynamicContent from 'component/page/detail/DetailPageModularize/ContentsHandler/DynamicContent';
import TabsComponent from 'component/page/detail/DetailPageModularize/ContentsHandler/TabsComponent';

export const TabsContentsHandler: React.FC<ContentHandlerProps> = (props) => {
    const { contents } = props;

    if (contents.length === 0) {
        return null;
    }

    return (
        <>
            <TabsComponent contents={contents} />
            <Container pt="16">
                <Stack direction="column">
                    {contents.map((content, index) => (
                        <DynamicContent config={content} key={index} />
                    ))}
                </Stack>
            </Container>
        </>
    );
};

TabsContentsHandler.displayName = 'TabsContentsHandler';
